import { AFFILIATE_CONFIG } from '../config';

const { affiliateId, campaignId, programId } = AFFILIATE_CONFIG.tcgplayer;
const BASE = `https://partner.tcgplayer.com/c/${affiliateId}/${campaignId}/${programId}`;

// Drop Scryfall's own utm_* attribution from a purchase URL so our
// placement label is the only attribution TCGPlayer receives. Anything
// non-utm (e.g. ?Language=English) survives untouched.
function stripUtm(url) {
    try {
        const u = new URL(url);
        Array.from(u.searchParams.keys())
            .filter((k) => k.toLowerCase().startsWith('utm_'))
            .forEach((k) => u.searchParams.delete(k));
        return u.toString();
    } catch {
        return url;
    }
}

function buildTrackedUrl(destinationUrl, { placement, sharedId } = {}) {
    if (!destinationUrl) return null;
    const cleaned = stripUtm(destinationUrl);
    const params = new URLSearchParams();
    if (placement) params.set('subId1', placement);
    if (sharedId) params.set('sharedid', sharedId);
    params.set('u', cleaned);
    return `${BASE}?${params.toString()}`;
}

export const tcgplayerProvider = {
    id: 'tcgplayer',
    name: 'TCGPlayer',
    region: 'NA',
    capabilities: { card: true, cart: true, search: true },

    wrap(destinationUrl, ctx) {
        return buildTrackedUrl(destinationUrl, ctx);
    },

    cardUrl(card, ctx) {
        const url = card?.vendorRefs?.tcgplayer?.url || card?.purchaseUris?.tcgplayer || null;
        if (!url) return null;
        return buildTrackedUrl(url, ctx);
    },

    cartUrl(deck, ctx) {
        const cards = Array.isArray(deck?.cards) ? deck.cards : [];
        if (cards.length === 0) return null;
        // TCGPlayer mass entry: `<count> <name>` joined by `||`.
        const list = cards.map((c) => `${c.count || 1} ${c.name}`).join('||');
        const massEntry = `https://www.tcgplayer.com/massentry?productline=Magic&c=${encodeURIComponent(list)}`;
        return buildTrackedUrl(massEntry, ctx);
    },

    searchUrl(query, ctx) {
        if (!query) return null;
        const search = `https://www.tcgplayer.com/search/magic/product?productLineName=magic&q=${encodeURIComponent(
            query
        )}`;
        return buildTrackedUrl(search, ctx);
    },
};
